import type { $Fetch } from 'ofetch';
import type {
  LivroRegistro, LivroRegistroItem, AbrirLivroRegistroCommand, AddLivroRegistroItemCommand,
} from '@/domain/model/LivroRegistro';
import type { LivroRegistroGateway } from '@/application/port/out/LivroRegistroGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/livros-registros';

/** HTTP gateway do livro de registros. Authorities `acadadmin:livro:read|manage`. */
export class HttpLivroRegistroGateway implements LivroRegistroGateway {
  constructor(private readonly client: $Fetch) {}

  async list(educationLevelId?: string): Promise<LivroRegistro[]> {
    const params: Record<string, string> = {};
    if (educationLevelId) params['educationLevelId'] = educationLevelId;
    const res = await this.client<ApiResponse<LivroRegistro[]>>(PATH, { method: 'GET', params });
    assertApiSuccess(res); return res.data;
  }
  async abrir(cmd: AbrirLivroRegistroCommand): Promise<LivroRegistro> {
    const res = await this.client<ApiResponse<LivroRegistro>>(PATH, { method: 'POST', body: cmd });
    assertApiSuccess(res); return res.data;
  }
  async fechar(id: string, termoFechamento: string | null): Promise<LivroRegistro> {
    const res = await this.client<ApiResponse<LivroRegistro>>(
      `${PATH}/${encodeURIComponent(id)}/fechar`, { method: 'POST', body: { termoFechamento } });
    assertApiSuccess(res); return res.data;
  }
  async listItens(id: string): Promise<LivroRegistroItem[]> {
    const res = await this.client<ApiResponse<LivroRegistroItem[]>>(
      `${PATH}/${encodeURIComponent(id)}/itens`, { method: 'GET' });
    assertApiSuccess(res); return res.data;
  }
  async addItem(id: string, cmd: AddLivroRegistroItemCommand): Promise<LivroRegistroItem> {
    const res = await this.client<ApiResponse<LivroRegistroItem>>(
      `${PATH}/${encodeURIComponent(id)}/itens`, { method: 'POST', body: cmd });
    assertApiSuccess(res); return res.data;
  }
}
